import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./plugins";
import VueRouter from "vue-router";
//import * as firebase from "firebase";
import ToggleButton from "vue-js-toggle-button";
import firebase from "firebase/compat/app";
import { config } from "./helpers/firebaseConfig";
import "firebase/compat/auth";
import "firebase/compat/functions";
import "firebase/compat/firestore";
import { store } from "./store";
import AlertCmp from "./components/Alert.vue";
//import "material-design-icons-iconfont/dist/material-design-icons.css";
// import * as VueGoogleMaps from "vue2-google-maps";
import EditItemDetailsDialog from "./components/Edit/EditItemDetailsDialog.vue";

import DeleteItemDetailsDialog from "./components/Edit/DeleteItemDetailsDialog.vue";
// import VueGtag from "vue-gtag";
// firebase.initializeApp(config)
import Hotjar from "vue-hotjar";
import VueMeta from "vue-meta";
import "firebase/performance";
import Swal from "sweetalert2";
import VueSocialChat from "vue-social-chat";
import Vuelidate from "vuelidate";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import InstantSearch from "vue-instantsearch";
import "./registerServiceWorker";
import VueCompositionApi from "@vue/composition-api";
import VueGtm from '@gtm-support/vue2-gtm';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
// import SimpleAnalytics from "simple-analytics-vue";
import HoneybadgerVue from '@honeybadger-io/vue'
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import VueGtag from "vue-gtag";
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import vuetify from "./plugins/vuetify";
// import SimpleAnalytics from "simple-analytics-vue";
// import HoneybadgerVue from '@honeybadger-io/vue'
// import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import * as dotenv from 'dotenv'
import 'vue-googlemaps/dist/vue-googlemaps.css';
// import VueGoogleMaps from 'vue-googlemaps';
import * as VueGoogleMaps from "vue2-google-maps";
import { getFirestore, doc, getDoc } from 'firebase/firestore';
// import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

// Vue.use(VuetifyGoogleAutocomplete, {
//   apiKey: 'AIzaSyDuW8fg81kkYd_XiuEHsRRjAYhHVDxnstQ', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
//  // version: '...', // Optional
//   //language: '...', // Optional
//   //installComponents: true, // Optional (default: true) - false, if you want to locally install components
//   vueGoogleMapsCompatibility: true, // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
// });

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDuW8fg81kkYd_XiuEHsRRjAYhHVDxnstQ",
    libraries: "places",

  },
});
dotenv.config()

window.Swal = Swal;

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

require('dotenv').config({ debug: true })

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "xxxxxxxxs",
//     // This is required to use the Autocomplete plugin
//     libraries: "places" // 'places,drawing,visualization'
//   }
// });

// const honeybadgeConfig = {
//   apiKey: 'hbp_yx9loiqYT2SRqki0uFTHeBdX1IJtME2ifllq',
//   environment: 'production'
// }

// Vue.use(HoneybadgerVue, honeybadgeConfig)

Vue.use(VueGtag, {
  config: { id: "G-DBJPM32B2B" }
});

// Vue.use(SimpleAnalytics, { skip: process.env.NODE_ENV !== "production" });

Vue.use(VueCompositionApi);

Vue.use(VueGoogleMaps, {
  load: {
    // your Google API key
    apiKey: 'AIzaSyB-LNKBT7nHto0I0Q5ALS378wsoAiYj1FE',
  },
});

window.Toast = Toast;

Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(VueRouter);
// Vue.use(VueTelInputVuetify);
Vue.use(VueSocialChat);
Vue.use(VueMeta);
Vue.use(Vuelidate);
Vue.use(ToggleButton);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB-lpQeJN0g6jnJNG37y6xmWabd5Zs4sRM",
    libraries: "places",
    // region: "ZA"
  },
  installComponents: true
});

Vue.use(VueTelInputVuetify, {
  vuetify,
});

// Vue.use(VuetifyGoogleAutocomplete, {
//   apiKey: 'AIzaSyB-lpQeJN0g6jnJNG37y6xmWabd5Zs4sRM',
//   installComponents: true,
// })

Vue.use(VueGtm, {
  id: 'GTM-WDWGGWF',
  //  id: 'GTM-N94S2R6', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']


  queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    // gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    // gtm_preview: 'env-4',
    // gtm_cookies_win: 'x'
  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false,// Whether or not call trackView in Vue.nextTick
  if(localhost) { // disable GA:
    window['ga-disable-GTM-WDWGGWF'] = true; // enter your tracking ID
  }
});


Vue.use(Hotjar, {
  id: "2571346" // Hotjar Site ID
});
Vue.component("app-alert", AlertCmp);
Vue.component("app-edit-item-details-dialog", EditItemDetailsDialog);
Vue.component("app-delete-item-details-dialog", DeleteItemDetailsDialog);
Vue.component("font-awesome-icon", FontAwesomeIcon);


// firebase.auth().onAuthStateChanged((user) => {
//   if (user) {
//     this.user = user
//   }
// })
// Vue.use(VueGtm, {
//   id: 'GTM-WDWGGWF',
//   //  id: 'GTM-N94S2R6', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']


//   queryParams: {
//     // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
//     // gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
//     // gtm_preview: 'env-4',
//     // gtm_cookies_win: 'x'
//   },
//   defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
//   compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
//   nonce: '2726c7f26c', // Will add `nonce` to the script tag
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
//   trackOnNextTick: false,// Whether or not call trackView in Vue.nextTick
//   if(localhost) { // disable GA:
//     window['ga-disable-GTM-WDWGGWF'] = true; // enter your tracking ID
//   }
// });

// Sentry.init({
//   Vue,
//   dsn: "https://e7c1b964ca4844bab5623669390ac318@o4504774992265216.ingest.sentry.io/4504775049347072",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracePropagationTargets: ["localhost", "my-site-url.com", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

new Vue({
  router,
  vuetify,
  store,
  async beforeCreate() {


    // console.log(process.env)


    //use this to disable console logs
    // if (window) {
    //   window.console.log = function () { };
    //   window.console.debug = function () { };
    //   window.console.error = function () { };
    // }

    firebase.initializeApp(config);
    this.$store.dispatch("loadBookings");
    // this.$store.dispatch('setDb', firebase.firestore().collection('items'))

    // if (process.env.VUE_APP_NODE_ENV === 'development') {

    //   // firebase.firestore().useEmulator("localhost", 8081);


    //   firebase.functions().useEmulator("localhost", 5001);

    // }



    firebase.auth().onAuthStateChanged(async function (user) {
      if (user) {
        //  this.$router.push('/home')
        // console.log('user from ', user);
        // const firstName = user.displayName.split(' ')[0]

        const userData = {
          id: user.uid,
          email: user.email,
        };

        const db = getFirestore();
        const userRef = doc(db, "users", userData.id);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          console.log("public data:", docSnap.data());

          var publicData = docSnap.data();

          const privateRef = doc(db, "users", userData.id, "privateData", userData.id);
          const privateSnap = await getDoc(privateRef);

          store.commit("setOnboarding", publicData.onboarded)

          if (privateSnap.exists()) {
            console.log("load User Private Document data:", privateSnap.data());

            var privateData = privateSnap.data();

            var user = {
              ...publicData,
              ...privateData
            };

            store.commit("setUser", user);
          } else {
            console.log("Private Data not reached!");
            var user = {
              ...publicData
            };
            store.commit("setUser", user);

          }
          store.commit("setUser", user);

          console.log("load User Document data:", user);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }

        store.dispatch("setUser", userData);
        store.dispatch("loadRooms", userData.id);
        store.dispatch("loadUserBookings", userData.id);
        store.dispatch("loadUser", userData.id);
      } else {
        // this.$router.push('/register')
        // this.userstate == false;
        // console.log("No user is signed in.");
      }

    })

    // store.dispatch("loadUserBookings", this.$store.getters.user.id);

    // this.$store.dispatch("fetchUserData");
    this.$store.dispatch("loadItems");
    this.$store.dispatch("loadReviews");
    // console.log('requests')


  },
  beforeMount() {
    // this.$store.dispatch("loadBookings");
  },
  render: h => h(App)
}).$mount("#app");

export const functions = firebase.functions();
export const firebaseAuth = firebase.auth();
export const db = firebase.firestore();
export const auth = firebase.auth();

// export const dbItemRef = db.collection.apply("items");
